export default "__VITE_ASSET__CsH7zJ$F__"